import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Trophy } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card } from '../components/ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LeaguePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [league, setLeague] = useState(null);

  useEffect(() => {
    fetchLeagueData();
  }, [id]);

  const fetchLeagueData = async () => {
    try {
      const response = await axios.get(`${API}/leagues/${id}`);
      setLeague(response.data);
    } catch (error) {
      toast.error('Failed to fetch league data');
      console.error('Error:', error);
    }
  };

  if (!league) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%)' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%)' }}>
      <div className="backdrop-blur-md bg-white/5 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <button 
            onClick={() => navigate('/')} 
            className="flex items-center text-gray-400 hover:text-white transition-colors mb-4"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </button>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Card className="glass-card" data-testid="league-details">
          <div className="flex items-center space-x-4 mb-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center">
              <Trophy className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-4xl font-bold" data-testid="league-name">{league.name}</h1>
              <p className="text-gray-400">{league.short_name} • {league.level}</p>
            </div>
          </div>
          
          {league.description && (
            <p className="text-gray-300 leading-relaxed mb-6" data-testid="league-description">
              {league.description}
            </p>
          )}
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <span className="text-gray-400">Country</span>
              <p className="font-bold" data-testid="league-country">{league.country}</p>
            </div>
            <div>
              <span className="text-gray-400">Level</span>
              <p className="font-bold" data-testid="league-level">{league.level}</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}